import BudgetService from 'src/services/budget.service';
import { LoaderState } from 'src/types/loader-state.enum';
import budgetStyles from 'src/components/atomic/pages/budgets/budgetStyles.module.scss';
import BudgetTrackerCard from 'src/components/atomic/molecules/budgetTrackerCard/BudgetTrackerCard';
import React from 'react';
import { useSyncingAccounts } from 'src/hooks/useSyncingAccounts';
import { useCategories } from 'src/hooks/queries/categories';
import { useBudgets } from 'src/hooks/queries/budgets';
import CategoryEditButton from 'src/components/atomic/atoms/categoryEditButton/CategoryEditButton';
import styles from './budgetTrackers.module.scss';
import { TransactionType } from 'src/types/transaction-type.enum';

export default function BudgetTrackers(): JSX.Element {
    const { loaderState, isSyncingAccounts } = useSyncingAccounts();
    const { isLoading: isLoadingBudgets, data: budgets } = useBudgets();
    const { isLoading: isLoadingCategories, data: categories } = useCategories(TransactionType.TRANSACTION_EXPENSE);
    const isLoading = isLoadingBudgets || isLoadingCategories;

    if (isLoading) return null;

    return (
        <div className={styles.container}>
            {BudgetService.budgetsGroupedByCategory(budgets, categories).map((categoryBudgets) => {
                return (
                    <div className={styles.trackerCard} key={`${categoryBudgets[0].groupId}-card`}>
                        {categoryBudgets.map((budget, index) => {
                            return (
                                <div
                                    key={budget.groupId}
                                    className={loaderState === LoaderState.FADE_IN ? budgetStyles.fadeIn : ''}
                                    aria-busy={isSyncingAccounts}
                                    aria-live="polite"
                                >
                                    <BudgetTrackerCard
                                        budget={budget}
                                        parentName={index !== 0 ? categoryBudgets[0].groupName : undefined}
                                    />
                                </div>
                            );
                        })}
                    </div>
                );
            })}
            <div className={budgetStyles.budgetBottomButtons}>
                <CategoryEditButton location="bottom" />
            </div>
        </div>
    );
}
